






























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class Shopify extends Vue {
  @Prop({ default: '20' }) readonly width?: string;
  @Prop({ default: '23' }) readonly height?: string;
  @Prop({ default: '#3E24D6' }) readonly fill?: string;
}
